import {
  INextgenSubscription,
  NextgenSubscriptionStatus
} from "@wingspanhq/users/dist/lib/interfaces";

export interface IsNextGenSubscriptionEndedInput {
  subscription: INextgenSubscription;
  now?: Date;
}

// The Canceled status check is defensive — in practice cancellation
// deletes the record or sets subscriptionEndDate to the cancel time.
// A future-dated end means the member is still paid through that date.
export const selectorIsNextGenSubscriptionEnded = ({
  subscription,
  now = new Date()
}: IsNextGenSubscriptionEndedInput): boolean =>
  subscription.status === NextgenSubscriptionStatus.Canceled ||
  (!!subscription.subscriptionEndDate &&
    new Date(subscription.subscriptionEndDate) <= now);
